import { useContext } from 'react'
import { SetupContext } from 'src/consumer/context/SetupContext'
import ActivityPlanPage from '.'

export default function ActivityPlanWebWrapper(props) {
  const { setupData, setupLoading } = useContext(SetupContext)
  return <ActivityPlanPage {...props} setupData={setupData} setupLoading={setupLoading} />
}
